import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import styled from "styled-components/macro";

const Preloader = () => {
  return (
    <LoaderContainer>
      <CircularProgress />
    </LoaderContainer>
  );
};

const LoaderContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding: 20px;
`;

export default Preloader;
